// extracted by mini-css-extract-plugin
export default {"checkbox_container":"Layout_checkbox_container__GLpXw","disclaimer":"Layout_disclaimer__K3Fot","btn_main":"Layout_btn_main__JVASW"};